import { render, staticRenderFns } from "./DropdownConfiguration.vue?vue&type=template&id=71fb0b13&scoped=true&"
import script from "./DropdownConfiguration.vue?vue&type=script&lang=js&"
export * from "./DropdownConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb0b13",
  null
  
)

export default component.exports